import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-[80vh] items-center pt-32 pb-24">
      <Seo title="Checkout Cancelled — DISJINX" description="Checkout cancelled." path="/payment/cancel" noindex />
      <div className="mx-auto w-full max-w-2xl px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="font-display text-4xl font-extrabold tracking-tight lg:text-5xl">No charge made.</h1>
          <p className="mt-6 text-base leading-relaxed text-neutral-600 md:text-lg">
            You cancelled checkout — nothing was billed. Whenever you're ready, the plans will be waiting.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/" data-testid="payment-cancel-back-link" className="inline-flex items-center gap-2 bg-neutral-950 px-7 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-neutral-800">
              <ArrowLeft className="h-4 w-4" />
              Back to plans
            </Link>
            <Link to="/contact" data-testid="payment-cancel-contact-link" className="inline-flex items-center gap-2 border border-neutral-300 px-7 py-4 text-sm font-semibold transition-colors duration-200 hover:border-neutral-950">
              Ask a question first
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
}
